export const environment = {
  remote: false,
  realm: 'tamwilcom-dev',
  url: 'https://keycloak.neosys.business/',
  clientId: 'tamwilcom-front',

  SERVER_REFERENTIEL_API_URL: 'https://tamwilcom-referentiel.neosys.business',
  SERVER_EDITION_API_URL: 'https://tamwilcom-edition.neosys.business',
  SERVER_UTILISATEUR_API_URL: 'https://tamwilcom-utilisateur.neosys.business',
  SERVER_NOTIFICATION_API_URL: 'https://tamwilcom-notification.neosys.business',
  SERVER_REGLE_API_URL: 'https://tamwilcom-backoffice.neosys.business',
  SERVER_CHARGEMENT_API_URL: 'https://tamwilcom-chargement.neosys.business',
  SERVER_READ_API_URL: 'https://tamwilcom-backoffice.neosys.business',
  SERVER_SOCLE_API_URL: 'https://tamwilcom-backoffice.neosys.business',
  SIGNALR_HUB_URL: 'https://tamwilcom-backoffice.neosys.business',
  // SERVER_READ_API_URL: 'http://localhost:8080',
  SERVER_WORKFLOW_API_URL: 'https://tamwilcom-workflow.neosys.business',
  SERVER_BACKOFFICE_API_URL: 'https://tamwilcom-backoffice.neosys.business',
  SERVER_PLANIFICATION_API_URL: 'https://tamwilcom-planification.neosys.business',
  SERVER_MEJ_API_URL: 'https://tamwilcom-mej.neosys.business',
  SERVER_CFT_API_URL:  'https://tamwilcom-cft.neosys.business',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
import 'zone.js/plugins/zone-error'; // Included with Angular CLI.
